import { InputHelpText } from '@/components/ui/input-help-text'
import { Label } from '@/components/ui/label'
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue
} from '@/components/ui/select'
import { type TKey, useTranslation } from '@/translations/i18n'

export const INVENTORY_TYPE_OPTIONS = [
	{
		value: 'standard_mp_conversion',
		label: 'luxe_submissions:inventory_standard_mp_conversion'
	},
	{
		value: 'standard_nal',
		label: 'luxe_submissions:inventory_standard_nal'
	},
	{
		value: 'branded_residence_mp_conversion',
		label: 'luxe_submissions:inventory_branded_residence_mp_conversion'
	},
	{
		value: 'branded_residence_nal',
		label: 'luxe_submissions:inventory_branded_residence_nal'
	}
] as const satisfies readonly { value: string; label: TKey }[]

interface SourceFilterSelectProps {
	value: string | null
	onChange: (value: string | null) => void
	name: string
	errorMessage?: TKey
}

export function ListingTypeSelect({
	value,
	onChange,
	name,
	errorMessage
}: SourceFilterSelectProps) {
	const { t } = useTranslation()
	const selectedOption = INVENTORY_TYPE_OPTIONS.find(
		(opt) => opt.value === value
	)

	const handleValueChange = (newValue: string | null) => {
		// Toggle off if same value selected
		onChange(newValue === value ? null : newValue)
	}

	return (
		<div className='flex flex-col gap-2.5'>
			<Label htmlFor={name}>
				{t('luxe_submissions:listing_type_label')}
			</Label>
			<Select
				onValueChange={(val) => {
					if (val) {
						handleValueChange(val)
					}
				}}
				value={value}
			>
				<SelectTrigger className='w-full'>
					<SelectValue>
						{selectedOption
							? t(selectedOption.label)
							: t('luxe_submissions:select_listing_inventory')}
					</SelectValue>
				</SelectTrigger>
				<SelectContent className='w-(--anchor-width)'>
					{INVENTORY_TYPE_OPTIONS.map((option) => (
						<SelectItem key={option.value} value={option.value}>
							{t(option.label)}
						</SelectItem>
					))}
				</SelectContent>
			</Select>

			{errorMessage && <InputHelpText error={t(errorMessage)} />}
		</div>
	)
}
